import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import ContentView from '~/components/ContentView';
import EmergencyModeForm from '~/components/EmergencyModeForm';
import { useEnterEmergencyMode } from '~/hooks/api/useStartEmergencyMode';
import { useFetchCurrentEmergency } from '~/hooks/api/useFetchCurrentEmergency';
import EmergencyModeList from '~/components/EmergencyModeList';
import DrawerButton from '../DrawerButton';
import messages from './messages';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

const EmergencyMode = () => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const { data, isLoading } = useFetchCurrentEmergency();
  const mutation = useEnterEmergencyMode({
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.startingEmergencyModeFailed),
      });
    },
  });
  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <Grid
              container
              spacing={2}
              sx={{
                alignItems: 'center',
              }}
            >
              <Grid>
                <DrawerButton />
              </Grid>
              <Grid>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'inherit',
                  }}
                >
                  <FormattedMessage {...messages.title} />
                </Typography>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      }
      isLoading={isLoading}
      fullWidth={Boolean(data)}
    >
      {data?.emergency ? (
        <EmergencyModeList />
      ) : (
        <EmergencyModeForm
          onSubmit={(values) =>
            mutation.mutate({
              reason: values.reason,
              routeIds: values.routeIds,
            })
          }
        />
      )}
    </ContentView>
  );
};

export default EmergencyMode;
